module.exports = __webpack_public_path__ + "static/media/salao_atico_4.0e4a0afd.jpg";